import {
  getGroupPublicInfo,
  getGroupRolePermissions
} from "@/api/group/group";
const group = {
  state: {
    showDesc: true, // 是否显示群信息为非编辑状态
    groupInfo: {   // 群信息
      group_logo: "",
      group_description: "",
      group_name: "",
      group_category_name: "",
      group_member_identity: ""
    },
    isMember: false, // 是否群成员
    // 当前登录用户在该群的权限列表
    permissions: {
      public_operations: [],
      resource_operations: []
    }
  },
  mutations: {
    // 修改群信息编辑状态
    SET_GROUP_SHOWDESC: (state, showDesc) => {
      state.showDesc = showDesc;
    },
    // 设置群信息
    setGroupInfo(state, payload){
      state.groupInfo = payload;
    },
    // 设置是否群成员
    setIsMember(state, payload){
      state.isMember = payload;
    },
    // 设置登录用户在该群的权限列表
    setGroupPermission(state, payload){
      state.permissions = payload;
    },
    // 更新资源权限
    addGroupResourcePermission(state, payload) {
      if(state.permissions.resource_operations != 'ALL'){
        state.permissions.resource_operations.push(payload);
      }
    }
  },
  actions: {
    getGroupPublicInfo({dispatch, commit}, payload) {
      dispatch("getGroupRolePermissions", payload);
      return new Promise((resolve, reject) => {
        getGroupPublicInfo(payload)
          .then(res => {
            if (res.status_code === 200) {
              commit("setGroupInfo", res.entity);
              let isMember =
              ["owner", "admin", "user"].indexOf(
                res.entity.group_member_identity
              ) > -1;
              commit('setIsMember', isMember);
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          });
      })
    },
    async getGroupRolePermissions({commit}, payload) {
      return new Promise((resolve, reject) => {
        getGroupRolePermissions({
          group_id: payload
        })
          .then(res => {
            if (res.status_code === 200) {
              commit('setGroupPermission', res.entity);
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
            console.log(err)
          });
      })
    }
  }
}

export default group